import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GridRequerimento from 'containers/RequerimentoListar/gridRequerimento';
import Filtro from 'containers/RequerimentoListar/filtro';
import TitlePage from 'components/TituloPage';
import { fetchGetFormulariosByFilter } from 'store/fetchActions/fetchFormulario';
import { fetchSalvarInputsFormularios } from 'store/fetchActions/fetchInputForm';
import { formatterFiltroDuvidaServicoFrontToBack } from 'utils/formatter/filtro';
import { getRotaVoltar } from './Listar';
import * as S from './styles';
import * as Style from 'components/Style';

export default function PageListarRequerimento() {
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const configFiltroSalvo = useSelector(state => state.formulario.configFiltroPesquisa);
  const unitaryTests = useSelector(state => state.app.unitaryTests);

  const [filtroSelecionado, setFiltroSelecionado] = useState(configFiltroSalvo?.filtro);

  React.useEffect(() => {
    // PESQUISA INICIAL DOS DADOS PARA SEREM EXIBIDOS
    if (unitaryTests) return;
    dispatch(fetchSalvarInputsFormularios({}));
    handlePesquisar(filtroSelecionado, configFiltroSalvo?.page, configFiltroSalvo?.pageSize);
    // eslint-disable-next-line
  }, [dispatch, unitaryTests]);

  const handlePesquisar = (filtro, page = 1, pageSize = 10) => {
    const dadosFormatados = formatterFiltroDuvidaServicoFrontToBack(filtro);
    dispatch(fetchGetFormulariosByFilter(dadosFormatados, page, pageSize));
    setFiltroSelecionado(filtro);
  };

  return (
    <S.Page>
      <TitlePage textTitle="Listar Requerimentos" backPage={getRotaVoltar(user)} />
      <Filtro filtroInicial={filtroSelecionado} salvarFiltro={setFiltroSelecionado} handlePesquisar={handlePesquisar} />
      <S.ContainGrid>
        <Style.GlobalCard>
          <GridRequerimento filtros={filtroSelecionado} handlePesquisar={handlePesquisar} />
        </Style.GlobalCard>
      </S.ContainGrid>
    </S.Page>
  );
}
